import { render, staticRenderFns } from "./input-dropdown.vue?vue&type=template&id=8b6fffa6"
import script from "./input-dropdown.vue?vue&type=script&lang=js"
export * from "./input-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports